import {
  ResponsiveContextProvider,
  ResponsiveDetailCol,
  ResponsiveListCol
} from '@monorepo/common/component/responsive/ResponsiveContextProvider';
import React from 'react';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import PersonFilterableList from '../component/person/PersonFilterableList';
import PersonSwitchDetail from '../component/person/switch/PersonSwitchDetail';

export default function PersonsPage() {
  const { path: parentPath, url: parentUrl } = useRouteMatch();
  const path = `${parentPath}/:personId?`;
  const match = useRouteMatch<{ personId?: string }>(path);
  const personId = match?.params.personId;

  return (
    <ResponsiveContextProvider single={false} selectedId={personId}>
      <Route path={path}>
        <Container>
          <Row>
            <ResponsiveListCol>
              <div className="position-fixed-scrollable">
                <PersonFilterableList personId={personId} url={parentUrl} />
              </div>
            </ResponsiveListCol>

            <ResponsiveDetailCol>
              <PersonSwitchDetail personId={personId} listUrl={parentUrl} />
            </ResponsiveDetailCol>
          </Row>
        </Container>
      </Route>
    </ResponsiveContextProvider>
  );
}
